<template>
  <div class="value-per-department">
    <Chart :title="title" :currency="settings.currency">
      <template #chart>
        <HighChart v-if="chartData" :options="mergedChartData" />
      </template>
      <template #widget-options>
        <slot name="widget-options" />
      </template>
    </Chart>
  </div>
</template>

<script>
import * as apiTo from '../../../api'
import { customChartData } from './custom-chart-data'
// Libraries
import { merge } from 'lodash'
// Components
import { Chart as HighChart } from 'highcharts-vue'
import Chart from '../Chart'

export default {
  components: {
    Chart,
    HighChart
  },
  props: {
    title: String
  },

  data: () => ({
    chartData: null
  }),

  computed: {
    mergedChartData() {
      if (!this.chartData) return
      return merge(this.chartData.chart, this.customChartData)
    }
  },

  created() {
    this.customChartData = customChartData()
    apiTo.getChartData('value-per-department-over-time').then(({ data }) => (this.chartData = data.result))
  }
}
</script>
